import {
	LOGIN_OK,
	LOGIN_USER,
	LOGIN_FAIL,
	LOGIN_AGENCIES,
	LOGIN_CDMS,
	FORGOT_REQUEST,
	FORGOT_OK,
	LOGIN_REQUEST,
	LOGOUT,
	RESET_REQUEST, RESET_OK
} from './../store/config';

const loginInit = {
	isFetching: false,
	data: {
		profile: {},
		menu: [],
		agencies: [],
		cdms: [],
		version: {},
		timestamp: undefined
	},
	error: undefined,
	message: undefined,
	timestamp: undefined
}

function userLogin(state = loginInit, action){
	switch(action.type) {
		case LOGIN_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				message: action.message,
				error: action.payload,
				timestamp: action.timestamp
			}
		case LOGIN_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				message: action.payload,
				timestamp: action.timestamp
			}
		case LOGIN_AGENCIES:
			return {
				...state,
				data: {
					...state.data,
					agencies: action.payload
				},
				message: action.message
			}
		case LOGIN_CDMS:
			return {
				...state,
				data: {
					...state.data,
					cdms: action.payload
				},
				message: action.message
			}
		case LOGIN_USER:
			return {
				...state,
				data: {
					...state.data,
					profile: action.payload
				},
				message: action.message
			}
		case LOGIN_OK:
			return {
				...state,
				isFetching: action.isFetching,
				data: {
					...state.data,
					//menu: action.payload,
					version: action.version,
					//timestamp: action.timestamp
				},
				message: action.message,
				timestamp: action.timestamp
			}
		case LOGOUT:
			return {
				...loginInit,
				timestamp: action.timestamp
			}
		case FORGOT_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				message: action.payload,
				timestamp: action.timestamp
			}
		case FORGOT_OK:
			return {
				...state,
				isFetching: action.isFetching,
				message: action.payload,
				timestamp: action.timestamp
			}
		case RESET_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				message: action.payload,
				timestamp: action.timestamp
			}
		case RESET_OK:
			return {
				...state,
				isFetching: action.isFetching,
				message: action.payload,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default userLogin;



// WEBPACK FOOTER //
// ./src/reducers/login.js